import { render, staticRenderFns } from "./form-loader.vue?vue&type=template&id=4fadf0bc&scoped=true&"
import script from "./form-loader.vue?vue&type=script&lang=js&"
export * from "./form-loader.vue?vue&type=script&lang=js&"
import style0 from "./form-loader.vue?vue&type=style&index=0&id=4fadf0bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fadf0bc",
  null
  
)

export default component.exports